import { ChevronLeft, ChevronRight } from '@atom-learning/icons'
import * as React from 'react'

import { Icon } from '~/components/icon/Icon'
import { styled } from '~/styled'

import { useCarousel } from './Carousel'

const ArrowButton = styled('button', {
  base: [
    'items-center',
    'text-primary-800',
    'cursor-pointer',
    'flex',
    'justify-center',
    'size-12',
    'top-1/2',
    '-translate-y-1/2',
    'transition-colors',
    'duration-150',
    'ease-in-out',
    'hover:text-primary-900',
    'active:text-primary-1000',
    'disabled:text-grey-200',
    'disabled:cursor-not-allowed'
  ]
})

export const CarouselArrowPrevious = (
  props: React.ComponentProps<typeof ArrowButton>
) => {
  const { scrollPrev, canScrollPrev } = useCarousel()

  return (
    <ArrowButton
      type="button"
      onClick={scrollPrev}
      disabled={!canScrollPrev}
      aria-label="Previous slide"
      {...props}
    >
      <Icon is={ChevronLeft} />
    </ArrowButton>
  )
}

export const CarouselArrowNext = (
  props: React.ComponentProps<typeof ArrowButton>
) => {
  const { scrollNext, canScrollNext } = useCarousel()

  return (
    <ArrowButton
      type="button"
      onClick={scrollNext}
      disabled={!canScrollNext}
      aria-label="Next slide"
      {...props}
    >
      <Icon is={ChevronRight} />
    </ArrowButton>
  )
}
